import styled from 'styled-components/macro'
import {motion} from 'framer-motion'

export const popContainerVariants = { 
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
    },
    exit: {
        opacity: 0,
    }
}

export const popInnerVariants = {
    initial: {
        opacity: 0,
        y: 10,
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            ease: 'easeInOut',
        }
    },
    exit: {
        opacity: 0,
        y: 0
    }
}

export const PopContainer = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 800;
`
export const PopInner = styled(motion.div)`
    width: 20rem;
    height: 14rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: white;
    border-radius: 5px;
    padding: 1rem;
    z-index: 900;
    position: relative;

`

export const CloseButton = styled.div`
    position: absolute;
    top: 3px;
    right: 4px;
    cursor: pointer;
    
    svg {
        color: black;
    }
`